<template>
  <div class="page-content">
    <div class="banner">
      <img src="../assets/img/home1.jpg" />
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {}
</script>
<style lang="scss">
.page-content {
  padding-top: 412px;
  .banner {
    display: block;
    height: auto;
    img {
      position: relative;
      width: 100%;
      // height: 710px;
    }
  }
}
</style>
